import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { GlobalErrorHandlerService } from './global-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService, private errorHandler: GlobalErrorHandlerService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(req.url.includes("getFeedStockLoadInfoById"))
       return next.handle(req);
      
    if(req.url.includes("GetSecurityScreenControlsAccessByRoles"))
       return next.handle(req);
      
    if(req.url.includes("GetRegionalSites"))
      return next.handle(req);
      
    if(req.url.includes("HasContractDocument"))
      return next.handle(req);
      
    if(req.url.includes("GetLoadSlipByStreamId"))
      return next.handle(req);

    this.loaderService.show();
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An unknown error occurred.';
        let errorTitle = 'API Error';

        if (error.error instanceof ErrorEvent) {
          errorMessage = `Client Error: ${error.error.message}`;
          errorTitle = 'Network Error';
        } else {
          errorTitle = `Error ${error.status}`;
          switch (error.status) {
            case 0:
              // Network failed or API is down
              errorMessage = `Could not connect to the server. Please check your network or try again later.`;
              errorTitle = 'Connection Failed';
              break;
            case 400: // Bad Request (API validation failed, as seen in your image)
              // Attempt to extract a more user-friendly message from the body
              if (error.error && typeof error.error === 'string') {
                errorMessage = error.error;
              } else if (error.statusText) {
                errorMessage = error.error.message;
              } else {
                errorMessage = 'The request sent to the server was invalid.';
              }
              break;
            case 403: // Forbidden
              errorMessage = 'You do not have permission to perform this action.';
              break;
            case 404: // Not Found (Not explicitly mentioned, but common)
              errorMessage = 'The requested resource was not found.';
              break;
            case 500:
              errorMessage = 'The server encountered an internal error. Please contact support.';
              break;
            case 204: // No Content (Success, but no body—not usually an error, but can be handled if needed)
            case 50: // Assuming a custom or non-standard error
            default:
              errorMessage = `The API returned status code ${error.status}. Details: ${error.message}`;
              break;
          }
        }
        
        this.errorHandler.showError(errorMessage, "error");
        return throwError(() => error);
      }),
      finalize(() => this.loaderService.hide())
    );
  }
}